<div class="h-100" [caLocalizationScope]="LOCALIZATION_SCOPE">
  <div class="d-flex justify-content-between mt-3 mb-3">
    <span class="heading-20 mb-2" data-automation-id="portfolio-managers-count">
      {{ 'totalNoOfManagers' | caLocalize : { totalManagers: portfolioManagers?.length } }}
    </span>
    <a
      *ngIf="portfolioManagers?.length"
      data-automation-id="view-in-table-link"
      class="link link-primary body-50"
      target="_blank"
      [href]="getViewInTableLink()"
    >
      {{ 'viewInTable' | caLocalize }}
    </a>
  </div>

  <div>
    <f-list [withBackground]="true">
      <f-list-item *ngFor="let contact of portfolioManagers; index as rowIndex" [withHover]="false">
        <div class="row">
          <div class="col-12 col-sm-8" [class.my-2]="!contact.primaryEmail && !contact.primaryPhone">
            <div data-automation-id="first-line">
              <ng-container *ngTemplateOutlet="profileLinkTemplate; context: { $implicit: contact }"></ng-container>
            </div>
            <div
              class="list-group-secondary-text d-flex align-items-center"
              data-automation-id="second-line"
              (mouseenter)="onMouseEnter(rowIndex)"
              (mouseleave)="onMouseLeave(rowIndex)"
            >
              <span [title]="contact.primaryEmail" class="text-truncate py-1" data-automation-id="contact-email">{{
                contact.primaryEmail
              }}</span>

              <button
                *ngIf="
                  contact.primaryEmail && copyStatus[rowIndex]?.showCopyIcon && !copyStatus[rowIndex]?.showCheckIcon
                "
                class="btn btn-primary btn-simple-icon ca-btn-copy btn-sm"
                data-automation-id="contact-email-copy"
                [title]="'copyEmail' | caLocalize"
                (click)="copy(contact.primaryEmail, rowIndex)"
              >
                <i class="f-i f-i-copy"></i>
              </button>
              <i
                data-automation-id="contact-email-copied"
                [@iconAnimation]
                *ngIf="copyStatus[rowIndex]?.showCheckIcon"
                class="f-i f-i-md f-i-check text-success-600"
                [title]="'copied' | caLocalize"
              ></i>
            </div>
          </div>
          <div
            *ngIf="contact.primaryPhone"
            class="col-12 col-sm-4 d-flex align-items-center justify-content-sm-end mb-1 mb-sm-0"
          >
            <div
              class="text-truncate text-right body-50"
              data-automation-id="contact-number-info"
              [title]="contact.primaryPhone"
              [innerHTML]="contact.primaryPhone"
            ></div>
          </div>
        </div>
      </f-list-item>
    </f-list>
  </div>

  <ng-template #profileLinkTemplate let-contact>
    <div class="d-flex align-items-center">
      <ca-profile-preview-link
        [text]="contact.name"
        [prId]="contact.id?.prId"
        [type]="'Contact'"
        [backButtonPreviewDrawer]="true"
        class="link link-main pe-0 pe-sm-1 text-desktop-truncate"
        data-automation-id="single-contact-profile-link-preview"
      >
      </ca-profile-preview-link>

      <ca-primary-contacts-at-profiles-icon
        [profileType]="ProfileType.Fund"
        [prId]="contact.id?.prId"
        [crmId]="contact.id?.crmId"
        [companyContacts]="contact.companyContacts"
        [container]="'body'"
      ></ca-primary-contacts-at-profiles-icon>
      <ca-esg-tag *ngIf="contact.isEsg" [profileType]="ProfileType.Contact" class="ms-1"></ca-esg-tag>
    </div>
  </ng-template>
</div>
